export const FETCH_TEST_HISTORY_LOADING = "FETCH_TEST_HISTORY_LOADING";
export const FETCH_TEST_HISTORY_SILENT_LOADING =
  "FETCH_TEST_HISTORY_SILENT_LOADING";
export const FETCH_TEST_HISTORY_SUCCESS = "FETCH_TEST_HISTORY_SUCCESS";
export const FETCH_TEST_HISTORY_FAILED = "FETCH_TEST_HISTORY_FAILED";
export const CLEAR_TEST_HISTORY = "CLEAR_TEST_HISTORY";
